import { useRef } from 'react';
// @mui
import { AppBar, Box, BoxProps, Container, Link, Toolbar } from '@mui/material';
import { useTheme } from '@mui/material/styles';
// hooks
// utils
import { bgBlur } from '../../utils/cssStyles';
// config
import { HEADER } from '../../config-global';
// components
import Logo from '../../components/logo';
import LanguagePopover from '../../components/language-popover';
import useResponsive from '../../hooks/useResponsive';

// ----------------------------------------------------------------------

export default function Header() {
  const carouselRef = useRef(null);

  const theme = useTheme();

  const isDesktop = useResponsive('up', 'md');

  // const isOffset = useOffSetTop(HEADER.H_MAIN_DESKTOP);
  // quick fix: navbar
  const isOffset = true;

  const headerOptions = {
    // 'Unser Ansatz': '#overview',
    // 'Strategy Consulting': '#strategy-consulting',
    // 'Data Analytics & Implementation': '#data-analytics',
    // 'Business Development': '#business-development',
    // 'Training & Workshops': '#training',
    // 'DIY-Workshop': '#diy-workshop',
    // Team: '#team',
  };

  return (
    <AppBar ref={carouselRef} color="transparent" sx={{ boxShadow: 0 }}>
      <Toolbar
        disableGutters
        sx={{
          // height: {
          //   xs: HEADER.H_MOBILE,
          //   md: HEADER.H_MAIN_DESKTOP,
          // },
          transition: theme.transitions.create(['height', 'background-color'], {
            easing: theme.transitions.easing.easeInOut,
            duration: theme.transitions.duration.shorter,
          }),
          ...(isOffset && {
            ...bgBlur({ color: theme.palette.background.default }),
            height: {
              md: HEADER.H_MAIN_DESKTOP - 16,
            },
          }),
        }}
      >
        <Container sx={{ height: 1, display: 'flex', alignItems: 'center' }}>
          {/* Left Section: Logo */}
          <Box sx={{ display: 'flex', alignItems: 'center', ml: 2 }}>
            <Logo />
          </Box>

          {/* Middle Section: Header Options, centered */}
          {isDesktop && (
            <Box
              sx={{
                flexGrow: 1,
                display: 'flex',
                justifyContent: 'center', // This will center the header options horizontally
                alignItems: 'center',
              }}
            >
              {Object.entries(headerOptions).map(([option, id]) => (
                <Link
                // key={option}
                // href={id}
                // underline="none"
                // sx={{ ml: 2, color: theme.palette.text.primary, textAlign: 'center' }}
                // onClick={(e) => {
                //   e.preventDefault();
                //   const target = document.querySelector(id);
                //   if (target) {
                //     target.scrollIntoView({ behavior: 'smooth' });
                //   }
                // }}
                >
                  {option}
                </Link>
              ))}
            </Box>
          )}

          {/* Right Section: Language & Contact Us */}
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: isDesktop ? 'flex-start' : 'flex-end',
              flexGrow: isDesktop ? 0 : 1,
              gap: 1,
            }}
          >
            <LanguagePopover />
            <Link
              href="mailto:felix.vogelgesang@fpv-bt.com"
              target="_blank"
              rel="noopener"
              underline="none"
              sx={{
                ml: 2,
                px: 2,
                py: 1,
                // borderRadius: 5,
                bgcolor: 'primary.main',
                color: 'common.white',
                '&:hover': {
                  bgcolor: 'primary.dark',
                },
              }}
            >
              Kontaktieren
            </Link>
          </Box>
        </Container>
      </Toolbar>

      {isOffset && <Shadow />}
    </AppBar>
  );
}

// ----------------------------------------------------------------------

function Shadow({ sx, ...other }: BoxProps) {
  return (
    <Box
      sx={{
        left: 0,
        right: 0,
        bottom: 0,
        height: 24,
        zIndex: -1,
        m: 'auto',
        borderRadius: '50%',
        position: 'absolute',
        width: `calc(100% - 48px)`,
        boxShadow: (theme) => theme.customShadows.z8,
        ...sx,
      }}
      {...other}
    />
  );
}
